import type { IconSvgObject } from './types';

const CornerDownLeftIcon: IconSvgObject = [
  ["path", { d: "M5 15.002H12C15.7712 15.002 17.6569 15.002 18.8284 13.8304C20 12.6588 20 10.7732 20 7.00195V4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99996 20.002C8.99996 20.002 4.00001 16.3195 4 15.0019C3.99999 13.6843 9 10.002 9 10.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerDownLeftIcon;
